import { render, staticRenderFns } from "./SubscriptionTypeRow.vue?vue&type=template&id=563083af&"
import script from "./SubscriptionTypeRow.vue?vue&type=script&lang=js&"
export * from "./SubscriptionTypeRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports